import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import SubscriptionTable from './SubscriptionTable';
import { WebhookEndpoint } from '../types/types';
import { useMerchant } from '../../../contexts/MerchantContext';
import { Button } from '../../../components/core';
import WebhookDeleteModal from './WebhookDeleteModal';

type SubscriptionsTabProps = {
  webhooks: WebhookEndpoint[];
  onAddWebhookClick: () => void;
  onEditWebhook: (webhookSubscription: WebhookEndpoint) => void;
};

const SubscriptionsTab = (props: SubscriptionsTabProps) => {
  const { webhooks, onAddWebhookClick, onEditWebhook } = props;
  const { canUpdateMerchantSettings } = useMerchant();
  const [webhookToDelete, setWebhookToDelete] = useState<WebhookEndpoint>();

  const hasModifyAccess = canUpdateMerchantSettings();

  const handleOpenDeleteModal = (webhook: WebhookEndpoint) => {
    setWebhookToDelete(webhook);
  };

  const handleCloseDeleteModal = () => {
    setWebhookToDelete(undefined);
  };

  return (
    <Box sx={{ pt: 3, width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          mb: 4,
          gap: 2,
        }}
      >
        <Stack>
          <Typography variant="large" fontWeight="bold">
            Subscriptions
          </Typography>
          <Typography variant="small" color="text.secondary">
            {`${webhooks.length} Endpoint${webhooks.length === 1 ? '' : 's'}`}
          </Typography>
        </Stack>
        <Button
          theme="secondary"
          text="Add Subscription"
          sx={{ px: 2, width: { xs: '100%', md: 'auto' } }}
          onClick={onAddWebhookClick}
          disabled={!hasModifyAccess}
        />
      </Box>
      <SubscriptionTable
        onDelete={handleOpenDeleteModal}
        webhooks={webhooks}
        onEdit={onEditWebhook}
        readOnly={!hasModifyAccess}
      />
      {webhookToDelete && (
        <WebhookDeleteModal
          open={Boolean(webhookToDelete)}
          onClose={handleCloseDeleteModal}
          webhook={webhookToDelete}
        />
      )}
    </Box>
  );
};

export default SubscriptionsTab;
